import { SdkContext } from '../internal'
import type { AbandonedCart, AbandonedCartFilters, AbandonedCartsPage, RegisterCartResult } from '@/types/abandonedCarts'

const cleanQuery = (params: Record<string, unknown>): Record<string, unknown> =>
  Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))

/* F-102: abandoned checkouts. The community is the X-CommunityId's. */
export class AbandonedCartsResource {
  constructor(private ctx: SdkContext) {}

  /**
   * The signed-in member opened the checkout of a product. The API ignores a
   * free product, one the member already has and a company purchase
   * (`tracked: false` with the reason).
   */
  async register(body: { productId: string; companyId?: string }): Promise<RegisterCartResult> {
    return this.ctx.call({ httpMethod: 'POST', path: '/checkout/carts', hasBody: true }, { body })
  }

  /** Abandoned and recovered carts, newest first. Owner, admin and finance; anyone else 403. */
  async list(params: AbandonedCartFilters & { page?: number; limit?: number } = {}): Promise<AbandonedCartsPage> {
    const result = await this.ctx.raw<AbandonedCart[] | (Partial<AbandonedCartsPage> & { data?: AbandonedCart[] })>(
      { httpMethod: 'GET', path: '/abandoned-carts' },
      { query: cleanQuery({ ...params }) }
    )
    if (Array.isArray(result)) {
      return { items: result, pagination: { page: 1, total: result.length, totalPages: 1 } }
    }
    const items = result?.items || result?.data || []
    return { items, pagination: result?.pagination || { page: 1, total: items.length, totalPages: 1 } }
  }
}
